<template>
  <a :href="href" @click="click" target="_blank" class="standardButton flexwrap" :class="[inactive?'grey':colorClass, inactive?'':'clickable']">
    <div class="standardButtonInside" :class="[inactive?'':'active']">
      <span style="grid-column: 1/3; display: flex"><slot></slot></span>
      <div v-if="premium && !inactive && !this.profile.datas.is_premium" class="premiumButton flexwrap centercenter">
        <i class="fas fa-burn"></i>
      </div>
    </div>

  </a>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "standardButton",
  props:['premium', 'inactive', 'colorClass', 'href'],
  computed: {
    ...mapGetters('global', [
        'isMobile',
      'profile',
    ])
  },
  methods:{
    click: function(){
      if(!this.inactive){
        if(this.premium && !(this.profile.datas.is_premium || this.profile.datas.trial_days_left > 0)){
          this.$router.push({name:'premium'})
        }
        else{
          this.$emit('click')
        }
      }

    }
  }
}
</script>

<style scoped>
  .premiumButton{
    position: absolute;
    top: 0.4vw;
    right: 0.4vw;
    border-radius: 2vw;
    height: 1.2vw;
    width: 1.2vw;
    font-size: 0.55vw;
    color: #ffda7b;
    background-color: hsla(200, 20%, 10%,0.9);
  }

  .standardButton {
    position: relative;
    min-width: 8vw;
    width: fit-content;
    height: 2vw;
    justify-self: center;
    border-radius: 5vw;
    text-decoration: none;
    font-size: 120%;
    margin: 0 0.25vw 0 0.25vw;
    overflow: hidden;
  }

  .standardButtonInside {
    position: relative;
    display: grid;
    grid-template-columns: 1fr 1.5vw;
    justify-items: center;
    align-items: center;
    padding: 0 0.5vw 0 0.5vw;
    width: 100%;
    height: 100%;
  }
  .active:hover{
    background-color: #00000022;
  }


  @media screen and (max-device-width: 767px) {

    .standardButton {
      grid-template-columns: 1fr 6vw;
      min-width: 25vw;
      height: 8vw;
      border-radius: 20vw;
      margin: 0 1vw 0 1vw;
      padding: 0 2vw 0 2vw;
    }

    .premiumButton{
      border-radius: 6vw;
      top: 1vw;
      right: 1vw;
      height: 6vw;
      width: 6vw;
      font-size: 2vw;
    }

  }

</style>